export default {
  logo: require('./logo.png'),
}
